import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWikidataComponent } from './simple-icons-wikidata.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWikidataComponent ],
    exports:      [ SimpleIconsWikidataComponent ],
    bootstrap:    []
})
export class SimpleIconsWikidataModule {}
